/*
 * サブシステム名：
 * 機能名：定型コース一覧
 * 表示項目カスタマイズ(滋賀自工)
 */
import D2MSTD0450 from '@/views/MST/D2MSTD0450.js'
// import filter from '@/rahmen/utils/filters'

export default {
  extends: D2MSTD0450,
  name: 'MstTeikeiCorceListCustomForHNU',
  data: () => ({
    custoMizeHeaders: [
      { text: 'コースNo', value: 'teikeiCourseNo' },
      { text: 'コース名称', value: 'teikeiCourseNm' },
      { text: '得意先名称', value: 'tokuisakiDisp' },
      { text: '担当営業所', value: 'tantoEigyoshoDisp' },
      { text: '客先注文番号', value: 'chumonNo' },
      { text: '商品', value: 'hinmeiDisp' },
      { text: '発地', value: 'hatsuchiDisp' },
      { text: '発時刻', value: 'hatsuchiHmsDisp' },
      { text: '経由地１', value: 'keiyuchiId1Disp' },
      { text: '経由地２', value: 'keiyuchiId2Disp' },
      { text: '経由地３', value: 'keiyuchiId3Disp' },
      { text: '経由地４', value: 'keiyuchiId4Disp' },
      { text: '経由地５', value: 'keiyuchiId5Disp' },
      { text: '着地', value: 'chakuchiDisp' },
      { text: '着時刻', value: 'chakuchiHmsDisp' },
      { text: '往復種別', value: 'ohfukuSbtNm' },
      { text: '請求車種', value: 'seikyuShashuSbtNm' },
      { text: '運賃計算方法', value: 'unchinKeisanKbnNm' },
      { text: '走行距離', value: 'yoteiSokoKyoriDisp', align: 'end' },
      { text: '走行時間', value: 'yoteiSagyoJikanDisp', align: 'center' },
      { text: '数量', value: 'juchuSuryo', align: 'end' },
      { text: '単位', value: 'unitKbnNm' },
      { text: '重量', value: 'juchuJuryo', align: 'end' },
      { text: '単価', value: 'tanka', align: 'end' },
      { text: '運賃', value: 'kihonUnchin', align: 'end' },
      { text: '高速道路料', value: 'unchinHokaKingaku', align: 'end' },
      { text: '保管料', value: 'hokanKingaku', align: 'end' },
      { text: '荷役料', value: 'niekiKingaku', align: 'end' },
      { text: '運賃他(非)', value: 'unchinHokaHikazei', align: 'end' },
      { text: '立替金(非)', value: 'tatekaekinHikazei', align: 'end' },
      { text: '燃料サーチャージ', value: 'nenryoSurcharge', align: 'end' },
      { text: '積込料', value: 'tsumikomiKingaku', align: 'end' },
      { text: '取卸料', value: 'torioroshiKingaku', align: 'end' },
      { text: '待機時間', value: 'taikiJikanDisp', align: 'center' },
      { text: '待機時間単価', value: 'taikiJikanTanka', align: 'end' },
      { text: '待機時間料', value: 'taikiJikanKingaku', align: 'end' },
      { text: 'その他付帯業務料', value: 'futaiGyomuKingaku', align: 'end' },
      { text: '割増対象時間', value: 'warimashiTaishoJikanDisp', align: 'center' },
      { text: '割増単価(時間)', value: 'warimashiJikanTanka', align: 'end' },
      { text: '割増金額(時間)', value: 'jikanWarimashiKingaku', align: 'end' },
      { text: '割増距離', value: 'warimashiTaishoKyoriDisp', align: 'end' },
      { text: '割増単価(距離)', value: 'warimashiKyoriTanka', align: 'end' },
      { text: '割増金額(距離)', value: 'kyoriWarimashiKingaku', align: 'end' },
      { text: '割増その他', value: 'warimashiSonotaKingaku', align: 'end' },
      { text: '請求金額合計', value: 'seikyuGokei', align: 'end' },
      { text: '傭車額', value: 'yoshaUnchin', align: 'end' },
      { text: '傭車通行料', value: 'yoshaHiwayPrice', align: 'end' },
      { text: '運行手当', value: 'sagyoinTeateKingaku1', align: 'end' },
      { text: '高速ETC', value: 'sharyoKeihiHiwayEtc', align: 'end' },
      { text: '高速現金', value: 'sharyoKeihiHiwayGenkin', align: 'end' },
      { text: 'フェリー', value: 'sharyoKeihiFerry', align: 'end' },
      { text: '摘要', value: 'seikyuBiko' },
      { text: '連絡用備考', value: 'renrakuBiko' }
    ]
  }),
  computed: {
  },
  methods: {
  }
}
